/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Layout, Card, Table, Tag } from "antd";
import dayjs from "dayjs";

import { getAPI } from "../../../utils/common";
import { ALL_LAUNDRY_OUT } from "../../../constants/api";

const { Content } = Layout;

function LaundryOutReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    getAPI(
      ALL_LAUNDRY_OUT,
      (res) => {
        if (res.status) {
          const formatted = res.data.map((row, index) => ({
            key: index,
            Vendor: row.vendor?.name,
            Date: dayjs(row.out_date).format("DD MMM YYYY"),
            Amount: `₹ ${row.total_amount}`,
            Status: (
              <Tag color={row.status === "pending" ? "orange" : "green"}>
                {row.status}
              </Tag>
            ),
          }));
          setData(formatted);
        }
        setLoading(false);
      },
      () => setLoading(false),
      {}
    );
  }, []);

  const columns = [
    { title: "Vendor", dataIndex: "Vendor", width: 200 },
    { title: "Out Date", dataIndex: "Date", width: 150 },
    { title: "Amount", dataIndex: "Amount", width: 150 },
    { title: "Status", dataIndex: "Status", width: 120 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card title="Laundry Out Report">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default LaundryOutReport;
